module.exports = __webpack_public_path__ + "static/media/HomePage-PromoBanner-bg.422d267d.jpg";